enum Sizes {
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
    NONE = 'none',
}

export default Sizes
